import styles from "./Spacer.module.scss";
import * as React from "react";

export type SpacerProps = {
    space: number;
}

export const Spacer = ({space}: SpacerProps) => {
    return <div style={{marginTop: `${space}px`}} className={styles.spacer} />;
}